export const URL_BASE = process.env.REACT_APP_URL_BASE;
export const URL_TRAZER = process.env.REACT_APP_URL_TRAZER;
export const URL_TRACKING = process.env.REACT_APP_TRACKING_INFO;
export const URL_PUBLIC_NETWORK = process.env.REACT_APP_URL_PUBLIC_NETWORK;

export const urlAsset = `${URL_BASE}/asset`;
export const urlAction = `${URL_BASE}/action`;
export const urlConfig = `${URL_BASE}/config`;
export const urlConfigTemp = `${URL_BASE}/config/temp`;
export const urlConfigTempTransact = `${URL_BASE}/config/temp/transact`;
export const urlTracking = `${URL_TRACKING}/tracking`;
